import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  keyValueContainer: {
    width: "100%",
    padding: theme.spacing(0, 4)
  },
  keyValueHeader: {
    marginBottom: theme.spacing(2)
  },
  keyValueContent: {
    width: "100%",
    display: "grid",
    columnGap: theme.spacing(5),
    gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))"
  },
  keyValueContainerCard: {
    width: "100%"
  }
}));
function KeyValueTable({ title, children, mode = "default" }) {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(Box, { className: cx({ [classes.keyValueContainer]: mode === "default", [classes.keyValueContainerCard]: mode === "card" }) }, title && /* @__PURE__ */ React.createElement(Typography, { className: classes.keyValueHeader, variant: "h6" }, title), /* @__PURE__ */ React.createElement(Box, { className: classes.keyValueContent }, children));
}
export {
  KeyValueTable
};
//# sourceMappingURL=KeyValueTable.js.map
